export const stringToLowerCase = (str: string | undefined) => {
  if (!str) return "";

  const newStr = str.toLowerCase();

  return `${newStr[0].toUpperCase()}${newStr.substring(1)}`;
};
